module.exports = __webpack_public_path__ + "img/animacion-2d-3d_poster.85ec58ca.jpg";